<template>
  <div class="card__reports">
    <h1 class="card__reports-title">Reports</h1>
    <div class="card__reports-list">
      <template v-for="report in reports">
        <div :key="report.id" class="card__reports-item">
          <h1 class="card__reports-item__title" v-html="report.title"></h1>
          <p v-html="report.description"></p>
          <DownloadButtonWithIcon
            :file="report.file"
            @on-download="() => handleClickDownload(report.title)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
import DownloadButtonWithIcon from '../buttons/DownloadButtonWithIcon.vue';

export default {
  name: 'ViewReportsModalReports',
  components: {
    DownloadButtonWithIcon,
  },
  props: {
    reports: {
      type: Array,
      default: () => [],
    },
    contentId: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    handleClickDownload(reportTitle) {
      window.analytics.track(SEGMENT_EVENTS.DOWNLOAD_FOUNDATION_REPORT, {
        contentId: this.contentId,
        reportTitle,
        contentType: 'Foundational Reports',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card__reports {
  background: #ffffff;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  &-title {
    padding: 24px 28px 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #234025;
    @media (max-width: 960px) {
      padding: 24px 16px 0;
      font-size: 15px;
    }
  }
  &-item {
    padding: 24px 0;
    margin: 0 28px;

    @media (max-width: 960px) {
      padding: 16px 0;
      margin: 0 16px;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #a7b3c7;
    }
    &__title {
      font-size: 15px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: 0.1px;
      color: #234025;
      margin-bottom: 8px;
      @media (max-width: 960px) {
        font-size: 16px;
      }
    }
    &__description {
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      letter-spacing: 0.1px;
      color: #7b7d7a;
      margin-bottom: 12px;
      @media (max-width: 960px) {
        font-size: 12px;
      }
    }
  }
}
</style>
